import moment from "moment";

export const isSelfExcludedAuthResponse = (data) =>
	Boolean(data?.SelfExcluded ?? data?.self_excluded ?? data?.IsSelfExcluded);

export const isSelfExcludedLoginResponse = (data) =>
	Boolean(data?.Authenticated && isSelfExcludedAuthResponse(data));

export const getSelfExclusionRemainingParams = (data) => {
	const days = Number(data?.SelfExclusionDays ?? data?.self_exclusion_days ?? 0);
	const start = Number(data?.SelfExclusionStart ?? data?.self_exclusion_start ?? 0);

	if (days >= 1000000) {
		return { isPermanent: true };
	}

	const end = moment(start).add(days, "days");
	const duration = moment.duration(Math.max(0, end.diff(moment())));

	return {
		isPermanent: false,
		remainingDays: Math.floor(duration.asDays()),
		remainingHours: duration.hours(),
		remainingMinutes: duration.minutes(),
		endDate: end.format("DD.MM.YYYY, HH:mm"),
	};
};

export const getSelfExclusionLoginAlertPayload = (data) => {
	const remaining = getSelfExclusionRemainingParams(data);

	if (remaining.isPermanent) {
		return {
			type: "error",
			title: "SELF_EXCLUSION_H3",
			msg: "selfExclusion.loginPermanent",
		};
	}

	return {
		type: "error",
		title: "SELF_EXCLUSION_H3",
		msg: "selfExclusion.loginRemaining",
		msgParams: {
			remainingDays: remaining.remainingDays,
			remainingHours: remaining.remainingHours,
			remainingMinutes: remaining.remainingMinutes,
			endDate: remaining.endDate,
		},
	};
};
